import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const OrdersDashboard = () => {
  return <DashboardPageTemplate pageName={"orders"} />;
};
